import { EXCLUDED_MODULES } from "../constants"

// eslint-disable-next-line import/prefer-default-export
export const excludedModules = ({
  path,
  availableModules,
  flags: { bettermodeCommunity, cloudsinc },
}: {
  path: string
  availableModules: string[]
  flags: { bettermodeCommunity: boolean; cloudsinc: boolean }
}) => {
  const moduleId = path.slice(1)
  const isModuleAvailable = availableModules.includes(moduleId)

  if (isModuleAvailable) {
    // excluded modules defined in code
    if (EXCLUDED_MODULES.includes(moduleId)) return false
    // excluded modules defined via feature flag
    if (moduleId === "community") return bettermodeCommunity
    if (moduleId === "cloudsinc") return cloudsinc
  }

  // available modules
  return isModuleAvailable
}

const routeTitles: Record<string, string> = {
  "/crs": "Client Results",
  "/cloudsinc": "CloudSinc",
  "/community": "Community",
  "/cf": "Control Framework",
  "/iam": "Identity and Access Management",
  "/fts": "File Transfer Service",
  "/lrh": "London Reporting House",
  "/sds": "Shareholding Disclosure Service",
  "/ssil": "Short Selling Indicator Lookup",
  "/srb": "Single Rulebook",
  "/wiki": "Wiki",
  "/": "Home",
  "/home": "Home",
}

export const getDynamicTitleWithRoute = (route: string) => {
  if (route === "/") {
    return routeTitles[route]
  }
  // Find matching route path without using for...of loop
  return Object.keys(routeTitles)
    .filter((routePath) => routePath !== "/" && route.includes(routePath))
    .map((routePath) => routeTitles[routePath])[0]
}
